"use client"

/*eslint-disable */
import type { VariantProps } from "class-variance-authority"
import * as React from "react"
import * as TabsPrimitive from "@radix-ui/react-tabs"
import { cva } from "class-variance-authority"

import { BodyXs } from "@/domains/design/components/body-xs"
import { cn } from "@/domains/library"

const Tabs = TabsPrimitive.Root

const IDENTIFY_COMPONENTS = true

const tabsListVariants = cva("inline-flex items-center justify-center gap-0.5", {
  variants: {
    variant: {
      default: "bg-p400 text-t200",
      dark: "bg-p400 text-t200",
    },
  },
  defaultVariants: {
    variant: "default",
  },
})
const TabsList = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.List>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.List> & VariantProps<typeof tabsListVariants>
>(({ className, variant, ...props }, ref) => (
  <TabsPrimitive.List
    ref={ref}
    className={cn(
      IDENTIFY_COMPONENTS && "tabs-list",
      "bg-p200 text-t200",
      "border border-p300-shade hover:border-p300-light",
      "rounded-lg",
      "p-[2px]",
      tabsListVariants({ variant }),
      className,
    )}
    {...props}
  />
))
TabsList.displayName = TabsPrimitive.List.displayName

const TabsTrigger = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Trigger>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Trigger>
>(({ className, children, ...props }, ref) => (
  <TabsPrimitive.Trigger
    ref={ref}
    className={cn(
      IDENTIFY_COMPONENTS && "tabs-trigger",
      "data-[orientation=vertical]:w-full",
      "inline-flex items-center justify-center whitespace-nowrap",
      "rounded-md",
      "px-3 py-2",
      "bg-p500",
      "brightness-[1.10] hover:brightness-[1.45]",
      "text-t300",
      "transition-all duration-300 ease-in-out",
      "data-[state=active]:bg-primary data-[state=active]:text-t100 data-[state=active]:shadow-sm",
      "data-[state=active]:shadow-[inset_0px_1px_0px_hsla(0,0%,100%,0.16),0px_1px_2px_hsla(0,0%,0%,0.16)]",
      "ring-offset-none focus-visible:ring-none focus-visible:outline-none focus-visible:ring-offset-0",
      "disabled:pointer-events-none disabled:select-none disabled:opacity-25",
      className,
    )}
    {...props}
  >
    <BodyXs className="text-t300">{children}</BodyXs>
  </TabsPrimitive.Trigger>
))
TabsTrigger.displayName = TabsPrimitive.Trigger.displayName

const TabsContent = React.forwardRef<
  React.ElementRef<typeof TabsPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TabsPrimitive.Content>
>(({ className, ...props }, ref) => (
  <TabsPrimitive.Content
    ref={ref}
    className={cn(
      IDENTIFY_COMPONENTS && "tabs-content",
      "mt-2",
      "ring-none focus-visible:ring-none focus-visible:outline-none focus-visible:ring-offset-0",
      className,
    )}
    {...props}
  />
))
TabsContent.displayName = TabsPrimitive.Content.displayName

export { Tabs, TabsList, TabsTrigger, TabsContent }
